<i18n>
  {
  "en": {
  "title": "This contest is over!",
  "winners": "Contest winners",
  "discover_tuango": "Discover Tuango",
  "follow_us": "Follow us on your favourite social media"
  },
  "fr": {
  "title": "Ce concours est terminé!",
  "winners": "Gagnants du concours",
  "discover_tuango": "Découvrez Tuango",
  "follow_us": "Suivez-nous sur vos réseaux sociaux préférés"
  }
  }
</i18n>

<template>
  <div class="font-default">
    <main-image-section></main-image-section>
    <div class="container">
      <div class="row">
        <div class="col text-center">
          <div class="block p-t">
            <h1 class="fnt font-default-light">{{ $t("title") }}</h1>
            <p class="intro" v-if="$i18n.locale === 'fr'">
              Merci pour votre intérêt. Restez à l'affût de nos offres et
              concours en vous inscrivant à notre
              <a
                :href="
                  `https://www.tuango.ca/registration/?lang=${
                    $i18n.locale
                  }?utm_source=tuangoconcours2026&utm_medium=Link&utm_campaign=Contestendpage-${$i18n.locale.toUpperCase()}-2026`
                "
                >infolettre</a
              >.<br />
              Et n'oubliez pas de visiter notre section
              <a
                :href="
                  `https://www.tuango.ca/${
                    $i18n.locale
                  }/category/escapades?utm_source=tuangoconcours2026&utm_medium=Link&utm_campaign=Contestendpage-${$i18n.locale.toUpperCase()}-2026`
                "
                >Escapades</a
              >
              pour vous inspirer à vous évader!
            </p>
            <p v-else class="intro">
              Stay up-to-date with our offers and contests by signing up to our
              <a
                :href="
                  `https://www.tuango.ca/registration/?lang=${
                    $i18n.locale
                  }?utm_source=tuangoconcours2026&utm_medium=Link&utm_campaign=Contestendpage-${$i18n.locale.toUpperCase()}-2026`
                "
                >newsletter</a
              >.<br />
              And don't forget to view our
              <a
                :href="
                  `https://www.tuango.ca/${
                    $i18n.locale
                  }/category/escapades/?utm_source=tuangoconcours2026&utm_medium=Link&utm_campaign=Contestendpage-${$i18n.locale.toUpperCase()}-2026`
                "
                >Getaways</a
              >
              to inspire your next holiday!
            </p>

            <p>
              <a
                v-if="$i18n.locale === 'fr'"
                href="https://docs.google.com/document/d/1tdDadBqdLxtvoBJpH3CXH7kUa9V8F4m_cHwHB1XNHz8/edit?ts=5c51baf9"
                target="_blank"
                >{{ $t("winners") }}</a
              >
              <a
                v-else
                href="https://docs.google.com/document/d/1-nWmR-m6uLK7ir8EoUJC6OjAUCHR7xOmtg4_RDUEp1M/edit?ts=5c51bb12"
                target="_blank"
                >{{ $t("winners") }}</a
              >
            </p>
          </div>

          <div class="block">
            <div>
              <el-button type="primary" @click="gotoTuangoSite" class="fnt">{{
                $t("discover_tuango")
              }}</el-button>
            </div>
          </div>

          <div class="block p-b">
            <p>
              {{ $t("follow_us") }}
            </p>
            <social-links></social-links>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainImageSection from "../components/Layout/MainImageSection"
import SocialLinks from "../components/UI/SocialLinks"

export default {
  name: "ContestClosed",
  components: {
    MainImageSection,
    SocialLinks
  },
  computed: {
    year() {
      const d = new Date()
      return d.getFullYear()
    },
    nextYear() {
      return this.year + 1
    }
  },
  methods: {
    gotoTuangoSite() {
      const url = `https://www.tuango.ca/${this.$i18n.locale}/?utm_source=tuangoconcours2026&utm_medium=Button&utm_campaign=Contestendpage-FR-january2020`
      window.location.href = url
    }
  }
}
</script>
